import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ChannelBulkUpdateModalComponent } from './channel-bulk-update-modal.component';

@Injectable()
export class ChannelBulkUpdateModalService  {

  constructor(
    protected modalService: BsModalService
  ) {}

  showBulkUpdateModal(data: {assignmentId?: string[], channelIds?: string[], bsModalRef?: BsModalRef}) {
    const bsModalRef = this.modalService.show(ChannelBulkUpdateModalComponent, { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false });
    data.bsModalRef = bsModalRef;
    bsModalRef.content.data = data;
  }
}






// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel-bulk-update-modal.service.ts